import { RowSelection$1, Table, Row, Cell, Column } from "./Table.fs.js";
import { singleton, empty, choose, append, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { count, many, content as content_1 } from "../Api/Jobs.fs.js";
import { map, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Humanize_timeSpan, System_Int32__Int32_ToLocaleString, System_DateTimeOffset__DateTimeOffset_ToLocaleDateString } from "../Prelude.fs.js";
import file_saver from "file-saver";
import { adminContent, UserCell, dateTimeCell } from "./Prelude.fs.js";
import { utcNow, op_Subtraction } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { UploadNewJob } from "../Modals/Job.fs.js";

const columns = ofArray([new Column("startedTime", "Started", undefined), new Column("completedTime", "Completed", undefined), new Column("duration", "Duration", undefined), new Column("type", "Type", undefined), new Column("processed", "Processed", undefined), new Column("success", "Success", undefined), new Column("errors", "Errors", undefined), new Column("warnings", "Warnings", undefined), new Column("by", "Last Modified By", undefined)]);

function ProgressCell(progressCellInputProps) {
    const tasks = progressCellInputProps.tasks;
    const processed = progressCellInputProps.processed;
    const uploadTime = progressCellInputProps.uploadTime;
    const contentName = progressCellInputProps.contentName;
    const colour = progressCellInputProps.colour;
    const jobId = progressCellInputProps.jobId;
    const projectId = progressCellInputProps.projectId;
    return createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([colour, ["className", "is-clickable"], ["onClick", (_arg) => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (content_1(projectId, jobId, contentName).then((_arg_1) => {
            const contentResult = _arg_1;
            if (contentResult.tag === 1) {
                console.error(some(contentResult.fields[0]));
                return Promise.resolve();
            }
            else {
                const date = System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(uploadTime);
                file_saver(new Blob([contentResult.fields[0]], { 'type': "text/csv" }), `${date}-${contentName}`);
                return Promise.resolve();
            }
        }))));
        void pr;
    }], ["title", `${System_Int32__Int32_ToLocaleString(processed)}/${System_Int32__Int32_ToLocaleString(tasks)}`], ["value", processed], ["max", tasks]]))));
}

function rowRender(projectId, job) {
    return new Row(job.JobId, append(choose((x) => x, ofArray([map((c) => (new Cell("completedTime", dateTimeCell(c))), job.CompletedTime), map((c_1) => {
        const timeSpan = op_Subtraction(c_1, job.StartedTime);
        return new Cell("duration", createElement("time", {
            dateTime: toString(timeSpan),
            children: Humanize_timeSpan(timeSpan),
        }));
    }, job.CompletedTime)])), ofArray([new Cell("startedTime", dateTimeCell(job.StartedTime)), new Cell("type", job.Type), new Cell("processed", createElement(ProgressCell, {
        projectId: projectId,
        jobId: job.JobId,
        colour: ["className", "is-info"],
        contentName: "input.csv",
        uploadTime: job.StartedTime,
        processed: job.Processed,
        tasks: job.Tasks,
    })), new Cell("success", createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([["className", "is-primary"], ["title", `${System_Int32__Int32_ToLocaleString(job.Success)}/${System_Int32__Int32_ToLocaleString(job.Tasks)}`], ["value", job.Success], ["max", job.Tasks]]))))), new Cell("warnings", createElement(ProgressCell, {
        projectId: projectId,
        jobId: job.JobId,
        colour: ["className", "is-warning"],
        contentName: "warnings.csv",
        uploadTime: job.StartedTime,
        processed: job.Warnings,
        tasks: job.Tasks,
    })), new Cell("errors", createElement(ProgressCell, {
        projectId: projectId,
        jobId: job.JobId,
        colour: ["className", "is-danger"],
        contentName: "errors.csv",
        uploadTime: job.StartedTime,
        processed: job.Errors,
        tasks: job.Tasks,
    })), new Cell("tasks", job.Tasks), new Cell("by", createElement(UserCell, {
        projectId: projectId,
        userId: job.By,
    }))])));
}

export function Jobs(jobsInputProps) {
    let actions;
    const projectId = jobsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const patternInput_2 = reactApi.useState(empty());
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_1[1]((copyOfStruct = utcNow(), toString_1(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Jobs",
        columns: columns,
        initialFilters: empty(),
        onFiltersChange: patternInput_2[1],
        fetchData: (apiParams) => many(projectId, apiParams),
        fetchCount: (apiParams_1) => count(projectId, apiParams_1),
        rowRender: (job) => rowRender(projectId, job),
        refresh: patternInput_1[0],
        rowSelection: new RowSelection$1(0, []),
    });
    return adminContent(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "New Job"], ["onClick", (_arg) => {
        setAction("uploadJob");
    }]]))))), table, (action != null) ? ((actions = action, createElement(UploadNewJob, {
        projectId: projectId,
        close: close,
    }))) : undefined);
}

